// dashboardHeroRingColorApi.js

import axios from 'axios';

/** @param {number} handleId @param {string} color */
export async function saveDashboardHeroRingColor(handleId, color) {
  const { data } = await axios.post(
    '/api/user/private-dashboard/hero-ring-color-save',
    { handleId, color },
    { withCredentials: true },
  );
  return data;
}
